@if (selectedData == null) {
  <div id="CreateAdvContainer">
    @if (isLoading) {
      <div class="category-loading" role="status" aria-live="polite">
        <span class="category-spinner" aria-hidden="true"></span>
        <span>טוענים את האפשרויות...</span>
      </div>
    } @else if (loadError) {
      <div class="category-load-error" role="alert">
        <mat-icon aria-hidden="true">error_outline</mat-icon>
        <span>לא הצלחנו לטעון את האפשרויות</span>
        <button type="button" (click)="loadData()">נסו שוב</button>
      </div>
    }
    <div class="row">
      @for (category of firstCategory; track category) {
        <button
          type="button"
          class="categoryBox first"
          [ngClass]="[highlightSelectedData(category), disabled ? 'disabledBox' : '']"
          [disabled]="disabled"
          [attr.aria-pressed]="isSelected(category)"
          (click)="SelectMainCategory(category)">
          <span class="selection-check" aria-hidden="true">✓</span>
          <img [src]="category.icon" [alt]="category.name">
          <span class="category-name">{{category.name}}</span>
        </button>
      }
    </div>
    <div class="row">
      @for (category of secondCategory; track category) {
        <button
          type="button"
          class="categoryBox second"
          [ngClass]="[highlightSelectedData(category), disabled ? 'disabledBox' : '']"
          [disabled]="disabled"
          [attr.aria-pressed]="isSelected(category)"
          (click)="SelectMainCategory(category)">
          <span class="selection-check" aria-hidden="true">✓</span>
          @if (category.icon) {
            <mat-icon aria-hidden="true">{{category.icon}}</mat-icon>
          }
          <span class="category-name">{{category.name}}</span>
        </button>
      }
    </div>
    <div class="row">
      @for (category of thirdCategory; track category) {
        <button
          type="button"
          class="categoryBox third"
          [ngClass]="[highlightSelectedData(category), disabled ? 'disabledBox' : '']"
          [disabled]="disabled"
          [attr.aria-pressed]="isSelected(category)"
          (click)="SelectMainCategory(category)">
          <span class="selection-check" aria-hidden="true">✓</span>
          <span class="category-name">{{category.name}}</span>
        </button>
      }
    </div>
  </div>
}
